import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Grid, Tooltip } from '@mui/material';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import { CollapseCard, Autocomplete } from '@totalsoft/rocket-ui';
import { get, sequence } from '@totalsoft/change-tracking-react';
import { useTranslation } from 'react-i18next';
import { emptyArray, emptyString } from 'constants/emptyConst';
import { getTranslationByCount } from 'constants/common';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { CardDetailTitle } from '../../InsuranceStyles';

const getSelectedCoefficientDetail = details => {
  const value = (details |> sequence).find(detail => {
    return (detail.selected |> get) === true;
  })?.detailId;
  return value ? value |> get : emptyString;
};

const CascoCoefficientsComponent = ({
  lens,
  color,
  disabled,
  onCoefficientsSelectionChange,
  onDeleteCoefficientsSelection,
  cascoAllowEmptyAdditionalData,
  validation
}) => {
  const { t } = useTranslation();

  const getLimitTagsText = useCallback((more, singularTag, pluralTag) => getTranslationByCount(more, singularTag, pluralTag, t), [t]);

  return (
    <CollapseCard
      icon={PlaylistAddCheckIcon}
      iconColor={color}
      toggleOnHeaderClick
      title={
        <Tooltip title={t('Offer.Insurance.Coefficients')}>
          <CardDetailTitle>{t('Offer.Insurance.Coefficients')}</CardDetailTitle>
        </Tooltip>
      }
    >
      <Grid container spacing={1}>
        {(lens.cascoQuotation.coefficients |> sequence).map((coefficient, index) => (
          <Grid item xs={12} key={index}>
            {coefficient.allowMultipleDetails |> get ? (
              <Autocomplete
                id={`casco_coefficient_${lens.cascoQuotation.id |> get}_${index}`}
                isMultiSelection
                withCheckboxes
                isClearable={!disabled}
                limitTags={0}
                getLimitTagsText={more => getLimitTagsText(more, 'Selection', 'Selections')}
                fullWidth
                simpleValue
                label={coefficient.additionalDataName |> get}
                valueKey='detailId'
                labelKey='detailName'
                value={(coefficient.details |> sequence)
                  .filter(detail => (detail.selected |> get) === true)
                  .map(selectedDetail => selectedDetail.detailId |> get)}
                options={(coefficient.details |> get) || emptyArray}
                getOptionDisabled={() => disabled}
                onChange={selectedCoefficientDetails =>
                  onCoefficientsSelectionChange(selectedCoefficientDetails, coefficient.additionalDataTypeId |> get)
                }
                optionLabels={true}
                onDeleteMultiSelectionItem={detailId => onDeleteCoefficientsSelection(coefficient.additionalDataTypeId |> get, detailId)}
                error={!isValid(validation?.coefficients[index]?.details)}
                helperText={getErrors(validation?.coefficients[index]?.details)}
              />
            ) : (
              <Autocomplete
                id={`casco_coefficient_${lens.cascoQuotation.id |> get}_${index}`}
                fullWidth
                simpleValue
                isClearable={cascoAllowEmptyAdditionalData}
                label={coefficient.additionalDataName |> get}
                valueKey='detailId'
                labelKey='detailName'
                options={(coefficient.details |> get) || emptyArray}
                value={getSelectedCoefficientDetail(coefficient.details)}
                onChange={selectedCoefficientDetails =>
                  onCoefficientsSelectionChange(selectedCoefficientDetails, coefficient.additionalDataTypeId |> get)
                }
                disabled={disabled}
              />
            )}
          </Grid>
        ))}
      </Grid>
    </CollapseCard>
  );
};

CascoCoefficientsComponent.propTypes = {
  lens: PropTypes.object.isRequired,
  color: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  onCoefficientsSelectionChange: PropTypes.func.isRequired,
  onDeleteCoefficientsSelection: PropTypes.func.isRequired,
  cascoAllowEmptyAdditionalData: PropTypes.bool.isRequired,
  validation: PropTypes.object.isRequired
};
export default CascoCoefficientsComponent;
